import { useEffect, useState } from 'react';
import { ConnectorStatus } from '../components/ConnectorStatus';
import { MeasureCard } from '../components/viz/MeasureCard';
import { api, type HealthResponse } from '../lib/api';

export function Overview() {
  const [health, setHealth] = useState<HealthResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .health()
      .then(setHealth)
      .catch((err: unknown) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  return (
    <section>
      <h1>Welcome</h1>
      <p>
        Asset College analytics platform. Use the dashboards above for source-specific views.
        Operational data sources land in this overview as they come online.
      </p>

      <h2 className="section-title">Staff registry</h2>
      <div className="grid">
        <MeasureCard
          title="Active staff"
          spec={{ measure: 'staff.count_active' }}
          viz="kpi"
          description="People with status = active."
        />
        <MeasureCard
          title="Data quality queue"
          spec={{ measure: 'staff.unlinked_sources_count' }}
          viz="kpi"
          description="Open issues — source identifiers that need triage."
        />
        <MeasureCard
          title="Staff by group"
          spec={{ measure: 'staff.count_by_group' }}
          viz="bar"
          description="Active staff per canonical group."
        />
      </div>

      <h2 className="section-title">Platform health</h2>
      <div className="grid">
        <article className="health-card">
          <h3>API</h3>
          {error && <p className="error">{error}</p>}
          {!error && !health && <p>Checking…</p>}
          {health && (
            <dl className="kv">
              <dt>Status</dt>
              <dd>{health.ok ? 'OK' : 'Unhealthy'}</dd>
              <dt>Server time</dt>
              <dd>{health.time}</dd>
            </dl>
          )}
        </article>
        <ConnectorStatus />
      </div>

      <style>{styles}</style>
    </section>
  );
}

const styles = `
.section-title { font-size: 14px; font-weight: 600; color: var(--ac-grey-700); text-transform: uppercase; letter-spacing: 0.04em; margin: 24px 0 12px; }
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  align-items: stretch;
}
.health-card {
  background: var(--ac-white);
  border: 1px solid var(--ac-grey-200);
  border-radius: var(--ac-radius);
  padding: 16px 20px;
  box-shadow: var(--ac-shadow-sm);
}
.health-card h3 { margin: 0 0 8px; font-size: 14px; font-weight: 600; color: var(--ac-grey-700); text-transform: uppercase; letter-spacing: 0.04em; }
.kv { display: grid; grid-template-columns: max-content 1fr; gap: 6px 16px; margin: 0; }
.kv dt { color: var(--ac-grey-500); }
.kv dd { margin: 0; font-variant-numeric: tabular-nums; }
.error { color: #b00020; }
`;
